exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-item[data-v-2961c202]{padding:0 .5rem}.plugin-wrapper .plugin-product_swiper .carousel[data-v-2961c202]{position:relative;padding:0}@media screen and (min-width:48em){.carousel-item[data-v-2961c202]{padding:0 .6875rem}}@media screen and (min-width:64em){.carousel-item[data-v-2961c202]{padding:0 .5rem}.plugin-wrapper .plugin-product_swiper .carousel[data-v-2961c202]{padding:2.5rem 1.875rem 1.875rem}}@media screen and (min-width:75em){.plugin-wrapper .plugin-product_swiper .carousel[data-v-2961c202]{padding:0}}", ""]);

// exports
